import styled from 'styled-components';
import { toRem } from 'design';

const Breadcrumbs = styled.nav`
  position: relative;
  flex-flow: row nowrap;
  justify-content: flex-start;
  width: auto;
  height: auto;
  margin-bottom: ${toRem(11)};
`;

export default Breadcrumbs;
